import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {useGuides} from './GuidesContext';

// Capas que tapan la pantalla: con una abierta la barra espera. El último paso de una guía de Aprende
// suele ser el botón real, que abre un modal o un cajón, y la vuelta se ofrece cuando la persona
// termina lo suyo — encima del modal taparía su pie.
const COVERING_BODY_CLASSES = ['modal-open', 'line-edit-drawer-open'];

function layerOpen() {
    return COVERING_BODY_CLASSES.some((cls) => document.body.classList.contains(cls));
}

function useLayerOpen() {
    const [open, setOpen] = useState(layerOpen);
    useEffect(() => {
        const observer = new MutationObserver(() => setOpen(layerOpen()));
        observer.observe(document.body, {attributes: true, attributeFilter: ['class']});
        // El mismo clic que termina la guía suele abrir un modal, y reactstrap pone `modal-open` en ese
        // commit, ANTES de este efecto: el observer no ve esa mutación (review C-rp-fe-aprende-02).
        setOpen(layerOpen());
        return () => observer.disconnect();
    }, []);
    return open;
}

/**
 * «Volver a Aprende» después de terminar o cerrar una guía que se lanzó desde la página (C-03 del
 * recorrido con Pablo): la página abre la tarea que sigue. La dibuja `GuidesEntry` sin guía activa, y
 * se va al usarla, al cerrarla, al llegar a la página por otro lado o al empezar otra guía.
 */
export function GuideReturnBar() {
    const {t} = useTranslation();
    const {returnOffer, goBackToLearn, dismissReturnOffer} = useGuides();
    const covered = useLayerOpen();
    if (!returnOffer || covered) return null;
    return (
        <div className="guide-preview-hint guide-return-bar" role="status" data-testid="guide-return-bar">
            <span>{t('guides.return_text')}</span>
            <button type="button" className="guide-return-go" onClick={goBackToLearn}>
                {t('guides.back_to_learn')}
            </button>
            <button type="button" className="guide-return-close" aria-label={t('guides.hint_close')}
                    onClick={dismissReturnOffer}>×</button>
        </div>
    );
}
